import { GatsbyBrowser, GatsbySSR } from "gatsby";
import React from "react";

import WrapRootElement from "./wrapRootElement";
const wrapRootElement: GatsbyBrowser["wrapRootElement"] &
  GatsbySSR["wrapRootElement"] = ({ element }) => (
  <WrapRootElement element={element} />
);
export { wrapRootElement };
